import { render, staticRenderFns } from "./infoEdit.vue?vue&type=template&id=680a3182&scoped=true&"
import script from "./infoEdit.vue?vue&type=script&lang=js&"
export * from "./infoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a3182",
  null
  
)

export default component.exports